<template>
  <div
    class="situation-wrap"
    v-loading="isLoading"
    element-loading-text="拼命加载中…"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 1)"
  >
    <!-- 导出图片确认 -->
    <CheckExportData
      :type-list="topCategories"
      v-if="checkExportVisible"
      v-loading="loadingPost"
      element-loading-text="拼命加载中…"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 1)"
      @handleExport="handleExport"
      @cancelExportImgs="checkExportVisible = false"
    ></CheckExportData>
    <!-- 电磁空间 -->
    <TopElectricChart
      ref="电磁空间"
      v-if="curSystemType === '电磁空间'"
      :categoryData="ChartDataContariner.categoryData"
      :tableData="tableData"
      :subcategoryNameList="ChartDataContariner.subcategoryNameList"
      :checkedSubcategoryNameList="ChartDataContariner.checkedSubcategoryNameList"
    >
      <CommonContainer
        class="map-wrap"
        :options="mapContainer.mapName"
        @handleSelect="handleCheckCountry"
        :title="mapContainer.mapTitle"
        :is-map="true"
      >
        <Map
          ref="地图"
          :mapType="mapType"
          @check="checkCountry"
          :selectedMode="mapContainer.selectedMode"
        >
          <!-- <el-button type="primary">导出所有图片</el-button> -->
          <template>
            <!-- <el-button type="primary" class="export-button" @click="checkExportVisible = true"
              >下载报告</el-button
            > -->
          </template>
        </Map>
      </CommonContainer>
    </TopElectricChart>

    <!-- 海洋信息 -->
    <TopSeaChart
      ref="海洋信息"
      v-if="curSystemType === '海洋信息'"
      :categoryData="ChartDataContariner.categoryData"
      :tableData="tableData"
      :subcategoryNameList="ChartDataContariner.subcategoryNameList"
      :checkedSubcategoryNameList="ChartDataContariner.checkedSubcategoryNameList"
    >
      <CommonContainer
        class="map-wrap"
        :options="mapContainer.mapName"
        @handleSelect="handleCheckCountry"
        :title="mapContainer.mapTitle"
        :is-map="true"
      >
        <Map
          ref="地图"
          :mapType="mapType"
          @check="checkCountry"
          :selectedMode="mapContainer.selectedMode"
        >
          <template>
            <!-- <el-button type="primary" class="export-button" @click="checkExportVisible = true"
              >下载报告</el-button
            > -->
          </template>
        </Map>
      </CommonContainer>
    </TopSeaChart>

    <footer class="footer-wrap">
      <CommonContainer
        :scale="styleContainer.footerChartStyle"
        :title="'技术'"
        :type-list="ChartDataContariner.subcategoryNameList.技术"
        @handleTypesSelect="handleTypesSelected"
      >
        <template slot-scope="scope">
          <LineChart
            ref="技术"
            :line-data="ChartDataContariner.categoryData.技术"
            :line-mode="'area-gradient'"
            :is-smooth="true"
            :area-opacity="0.5"
            :scale="styleContainer.chartScale"
            :is-show-legend-default="scope.chartStatus.isShowEnlargedChart"
            v-if="scope.chartStatus.isShowChart"
          ></LineChart>
          <DetailTable
            :table-data="tableData.技术"
            :type-list="ChartDataContariner.checkedSubcategoryNameList.技术"
            :is-show-region="true"
            v-else
          ></DetailTable>
        </template>
      </CommonContainer>
      <CommonContainer
        :scale="styleContainer.footerChartStyle"
        :title="'产品'"
        :type-list="ChartDataContariner.subcategoryNameList.产品"
        @handleTypesSelect="handleTypesSelected"
      >
        <template slot-scope="scope">
          <LineChart
            ref="产品"
            :line-data="ChartDataContariner.categoryData.产品"
            :line-mode="'link'"
            :scale="styleContainer.chartScale"
            :is-show-legend-default="scope.chartStatus.isShowEnlargedChart"
            v-if="scope.chartStatus.isShowChart"
          ></LineChart>
          <DetailTable
            :table-data="tableData.产品"
            :type-list="ChartDataContariner.checkedSubcategoryNameList.产品"
            :is-show-region="true"
            v-else
          ></DetailTable>
        </template>
      </CommonContainer>
    </footer>
  </div>
</template>

<script>
import Map from "@/components/Map"
import CommonContainer from "@/components/CommonContainer"
import LineChart from "@/components/Charts/LineChart"
import TopElectricChart from "./topElectricChart.vue"
import TopSeaChart from "./topSeaChart.vue"
import { service } from "@/utils/request"
import DetailTable from "@/components/Tables/DetailTable"
import { initData, updateRegionValue } from "@/views/News/index"
import CheckExportData from "../CheckExportData"
import topCategories from "@/modules/topCategories"

export default {
  props: {
    mapType: {
      type: String,
      require: true,
    },
  },
  components: {
    Map,
    TopElectricChart,
    CommonContainer,
    LineChart,
    TopSeaChart,
    DetailTable,
    CheckExportData,
  },
  data() {
    return {
      isLoading: true,
      loadingPost: false,
      curSystemType: this.$store.state.systemType,
      contractCountryName: "", // 当前对比国家的名称
      topCategories, //详细对比页面所有一级分类
      tableData: {
        政策法规: [],
        理论: [],
        行业应用: [],
        人才培养: [],
        技术: [],
        产品: [],
      },
      tableDataTemp: null, // 缓存tableData数据，放置切换子分类时被替换
      ChartDataContariner: {
        allSystemInformation: null,
        checkDataList: null,
        categoryData: {}, // 每个大类下的图表数据
        subCategoryData: {
          // 精确到子分类的图表数据，用于拼接categoryData
          政策法规: {},
          理论: {},
          行业应用: {},
          人才培养: {},
          技术: {},
          产品: {},
        },
        chinaData: {}, // 默认对比的数据
        subcategoryNameList: {}, // 大类下的子分类名称数组
      },
      mapContainer: {
        mapTitle: "地图",
        selectedRegion: [],
        selectedMode: "single",
        mapName: [], // 全球国家名称
      },
      styleContainer: {
        topChartStyle: { width: "22vw", height: "29vh" },
        topElectricChartStyle: { width: "22vw", height: "50vh" },
        footerChartStyle: { width: "47vw", height: "29vh" },
        chartScale: { width: "100%", height: "100%" },
      },
      checkExportVisible: false,
    }
  },
  computed: {
    watchSystemType() {
      return this.$store.getters.getSystemType
    },
  },
  watch: {
    watchSystemType: async function (newSystemType) {
      // console.log(`watch value ${n}`)
      await updateRegionValue(this, newSystemType)
      this.curSystemType = newSystemType
      if (this.contractCountryName) {
        this.initCountry(this.contractCountryName)
      } else {
        this.initCountry()
      }
    },
  },
  methods: {
    /**
     * 清空数据
     */
    clearData(country) {
      this.tableData = {
        政策法规: [],
        理论: [],
        行业应用: [],
        人才培养: [],
        技术: [],
        产品: [],
      }
      this.ChartDataContariner.subcategoryNameList = {
        政策法规: [],
        理论: [],
        行业应用: [],
        人才培养: [],
        技术: [],
        产品: [],
      }
      for (let key in this.ChartDataContariner.checkedSubcategoryNameList) {
        this.ChartDataContariner.checkedSubcategoryNameList[key].length = 0
      }
      // this.ChartDataContariner.checkedSubcategoryNameList = {
      //   政策法规: [],
      //   理论: [],
      //   行业应用: [],
      //   人才培养: [],
      //   技术: [],
      //   产品: [],
      // }
      this.ChartDataContariner.subCategoryData = {
        china: {
          政策法规: {},
          理论: {},
          行业应用: {},
          人才培养: {},
          技术: {},
          产品: {},
        },
        [country]: {
          政策法规: {},
          理论: {},
          行业应用: {},
          人才培养: {},
          技术: {},
          产品: {},
        },
      }
      this.ChartDataContariner.categoryData = {} // 清空
    },

    /**
     * map上国家选中高亮，失效
     */
    highlightCountry(country) {
      // let list = this.$store.state.regionValue   // 国家列表
      // list.global[0].selected = true
      // this.$store.commit("setRegionValue", list)
      console.log("map上国家选中高亮", country)
    },

    /**
     * 地图区域点击事件
     * @param data 区域名称
     */
    async checkCountry(data) {
      this.isLoading = true
      if (data === "中国") {
        this.$message.warning("请选择其他国家与中国对比")
        this.isLoading = false
        return
      }

      let temp = await initData(this, data, false)
      if (!Object.keys(temp.海洋信息).length && !Object.keys(temp.电磁空间).length) {
        alert("请选择有情报的地区进行对比")
        return
      }

      this.clearData(data) // 清空数据

      this.highlightCountry(data) // map上国家高亮

      // console.log("选择了", data)
      this.contractCountryName = data // 赋值，当前对比的国家名称

      this.mapContainer.mapTitle = data + " vs 中国"

      this.ChartDataContariner.checkDataList = temp[this.$store.getters.getSystemType][data]

      // 处理table的数据
      this.getTableData(this.ChartDataContariner.checkDataList)
      this.getTableData(this.ChartDataContariner.chinaData)
      // console.log(this.tableData, "表格的数据")
      console.log(this.ChartDataContariner, 123312312)
      // 中国
      let china = this.getCountryCategoryData(this.ChartDataContariner.chinaData, {}, "china")
      // 对比的国家
      let contractCountry = this.getCountryCategoryData(
        this.ChartDataContariner.checkDataList,
        {},
        data
      )
      for (const v in china) {
        const unit = china[v].unit

        // 判断中国和对比国家该分类是否为null，如果是则设为{}
        china[v] || (china[v] = {})
        contractCountry[v] || (contractCountry[v] = {})

        // 删除中国和对比国家的unit属性
        delete china[v].unit
        delete contractCountry[v].unit

        const data = [
          {
            name: "中国",
            unit,
            data: china[v],
          },
          {
            name: this.contractCountryName,
            data: contractCountry[v],
          },
        ]
        this.$set(this.ChartDataContariner.categoryData, v, data)
      }
      this.tableDataTemp = JSON.parse(JSON.stringify(this.tableData)) // 缓存tableData
      for (const subCat in this.ChartDataContariner.categoryData) {
        this.ChartDataContariner.categoryData[subCat][0].subCategoryData =
          this.ChartDataContariner.subCategoryData.china[subCat]
        this.ChartDataContariner.categoryData[subCat][1].subCategoryData =
          this.ChartDataContariner.subCategoryData[this.contractCountryName][subCat]
      }

      this.isLoading = false

      // console.log(this.$store.getters.getRegionNameList, china, this.ChartDataContariner.categoryData,"ChartDataContariner.categoryData", this.tableData)
    },

    /**
     * 监听子分类点击事件，替换图表数据
     * @param {*} obj 对象 { name: title, checkedTypes }
     */
    handleTypesSelected(obj) {
      // console.log("分类名:", obj.name, ";选择的子分类数组:", obj.checkedTypes)
      //同步修改列表的类型选项列表
      this.ChartDataContariner.checkedSubcategoryNameList[obj.name].length = 0
      obj.checkedTypes.map((value) => {
        this.ChartDataContariner.checkedSubcategoryNameList[obj.name].push(value)
      })
      //************************************************************************ */
      let china = {},
        contractCountry = {}
      obj.checkedTypes.map((v) => {
        // v是子分类
        // 先处理中国的
        // val是年份
        for (const val in this.ChartDataContariner.subCategoryData.china[obj.name][v]) {
          if (!china[val]) {
            // 第一次出现该年份
            china[val] = this.ChartDataContariner.subCategoryData.china[obj.name][v][val]
          } else {
            china[val] += this.ChartDataContariner.subCategoryData.china[obj.name][v][val]
          }
        }
        for (const val in this.ChartDataContariner.subCategoryData[this.contractCountryName][
          obj.name
        ][v]) {
          if (!contractCountry[val]) {
            // 第一次出现该年份
            contractCountry[val] =
              this.ChartDataContariner.subCategoryData[this.contractCountryName][obj.name][v][val]
          } else {
            contractCountry[val] +=
              this.ChartDataContariner.subCategoryData[this.contractCountryName][obj.name][v][val]
          }
        }
      })

      this.ChartDataContariner.categoryData[obj.name] = [
        {
          name: "中国",
          data: china,
        },
        {
          name: this.contractCountryName,
          data: contractCountry,
        },
      ]
      //添加子分类数据
      for (const subCat in this.ChartDataContariner.categoryData) {
        this.ChartDataContariner.categoryData[subCat][0].subCategoryData =
          this.ChartDataContariner.subCategoryData.china[subCat]
        this.ChartDataContariner.categoryData[subCat][1].subCategoryData =
          this.ChartDataContariner.subCategoryData[this.contractCountryName][subCat]
      }

      const tableChangeArr = []
      this.tableDataTemp[obj.name].map((v) => {
        // 存在子分类，且在选中数组种
        if (v.categorySubName && obj.checkedTypes.includes(v.categorySubName)) {
          tableChangeArr.push(v)
        }
      })
      this.tableData[obj.name] = tableChangeArr

      // console.log(this.tableData, 88)
      // this.ChartDataContariner.categoryData[obj.name] // 赋值为新数据
      // this.tableData[obj.name] // 赋值为新数据
    },

    /**
     * 监听地图搜索框输入事件， 返回过滤后的地区名称
     * @param {*} str 输入的字符串
     * @return arr 过滤后的地区名称数组
     */
    handleCheckCountry(countryName) {
      // 需要套一个节流函数
      // let arr = []
      // this.mapContainer.mapName // 所有国家名称的列表，
      this.checkCountry(countryName)
      // this.mapContainer.mapName.map((v) => {
      //   if (v.includes(str)) {
      //     arr.push(v)
      //   }
      // })
      // console.log("输入：", countryName, "；过滤前：", this.mapContainer.mapName, "过滤后：")

      // return arr
    },

    /**
     * 处理table的数据， 结果需要有国家的分类数据；
     * - 同时处理子分类名称数组
     * @param {*} arr 国家下的所有数据
     */
    getTableData(arr) {
      let categorySubName = {
        政策法规: new Set(),
        理论: new Set(),
        行业应用: new Set(),
        人才培养: new Set(),
        技术: new Set(),
        产品: new Set(),
      }

      for (let i = 0; i < arr.length; i++) {
        if (!this.tableData[arr[i].categoryName]) continue // 没有该领域，跳过

        this.tableData[arr[i].categoryName].push(arr[i])

        // 存在子分类, 处理子分类数据
        if (arr[i].categorySubName) {
          // 推入子分类名称数据
          categorySubName[arr[i].categoryName].add(arr[i].categorySubName)
        }
      }

      for (const v in categorySubName) {
        this.ChartDataContariner.subcategoryNameList[v] = [...categorySubName[v]]
        // this.$set(this.ChartDataContariner.checkedSubcategoryNameList, v, [...categorySubName[v]])
      }

      this.ChartDataContariner.checkedSubcategoryNameList = JSON.parse(
        JSON.stringify(this.ChartDataContariner.subcategoryNameList)
      )
    },

    /**
     * 处理国家的数据
     * @param {*} countryList 国家下的所有数据
     * @return {*} 返回值  形如{’行业应用‘：{2019: 100, 2010: 100}，’理论‘： {2019: 100, 2010: 100}}

     */
    getCountryCategoryData(countryList, resObj, country) {
      const _this = this
      countryList.map((v) => {
        const curYear = v.datetime.split("-")[0]
        if (!resObj[v.categoryName]) {
          // 第一次出现的领域
          resObj[v.categoryName] = {
            [curYear]: v.quantity,
            unit: v.unit,
          }
        } else {
          if (!resObj[v.categoryName][curYear]) {
            // 第一次出现的年份
            resObj[v.categoryName][curYear] = v.quantity
          }
          resObj[v.categoryName][curYear] += v.quantity
        }

        // 处理子分类数据
        if (v.categorySubName && v.categoryName !== "新闻") {
          // 分类下第一次出现的子分类
          if (
            !_this.ChartDataContariner.subCategoryData[country][v.categoryName][v.categorySubName]
          ) {
            // 还未存入的子分类，一定也没有该年份
            _this.ChartDataContariner.subCategoryData[country][v.categoryName][v.categorySubName] =
              {
                [curYear]: v.quantity,
              }
          } else {
            if (
              !_this.ChartDataContariner.subCategoryData[country][v.categoryName][
                v.categorySubName
              ][curYear]
            ) {
              // 第一次出现的年份
              _this.ChartDataContariner.subCategoryData[country][v.categoryName][v.categorySubName][
                curYear
              ] = v.quantity
            }
            _this.ChartDataContariner.subCategoryData[country][v.categoryName][v.categorySubName][
              curYear
            ] += v.quantity
          }
        }
      })

      return resObj
    },

    /**
     * 获取后端数据
     */
    getServiceData() {
      return service.api
    },

    // 初始化选中数据
    initCountry(data) {
      if (arguments.length) {
        // 如果传了值 则触发这个值
        this.checkCountry(data)
        return
      }

      if (this.mapType === "domestic") {
        this.checkCountry("北京")
      } else if (this.mapType === "global") {
        this.checkCountry("欧盟")
      }
    },

    //处理导出图片数据,并向后端提交
    handleExport(itemList) {
      const mySet = new Set(["政策法规", "行业应用", "理论", "人才培养"])
      const imageDataObj = {}
      itemList.forEach((category) => {
        if (mySet.has(category)) {
          if (this.$store.getters.getSystemType === "海洋信息") {
            imageDataObj[category] = this.$refs["海洋信息"].$refs[category].handleSaveImage()
          } else {
            imageDataObj[category] = this.$refs["电磁空间"].$refs[category].handleSaveImage()
          }
        } else {
          imageDataObj[category] = this.$refs[category].handleSaveImage()
        }
      })

      this.loadingPost = true
      setTimeout(() => {
        this.loadingPost = false
        this.checkExportVisible = false
        console.log(imageDataObj)
      }, 1000)
    },
  },
  created() {
    // 中国数据初始化
    this.ChartDataContariner.chinaData =
      this.$store.getters.getChinaValue[this.$store.getters.getSystemType]["中国"]

    // 初始默认选择
    this.initCountry()

    this.mapContainer.mapName = this.$store.getters.getRegionNameList.global
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
$mainHeight: 60vh; // 上部的容器、图表、地图的高度
$footerHeight: calc(40vh - 10vh); // 30vh 底部的容器、图表
$fontColor: #ccc;

.el-button--primary:hover {
  background-color: #293e79;
}
.situation-wrap {
  height: calc(100vh - 61px);
  margin: 0 20px;
  // border: 1px solid;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;

  .main-wrap {
    width: 100%;
    height: $mainHeight;
    // border: 1px solid;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .map-wrap {
      width: 50vw;
      height: $mainHeight;

      & .export-button {
        background-color: transparent;
        border: 1px solid rgb(43, 57, 87, 0.4);
        padding: 2vh 1vw;
        color: $fontColor;
        &:hover {
          background-color: #293e79;
        }
      }
    }

    .topChart-wrap {
      width: calc((100% - 50vw - 2vw) / 2); // 24vw
      height: $mainHeight;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }
    // .topChart-wrap > div:not(.angle){   // 未生效，需要加在content-area上
    //   height: 60vh;
    //   display: flex;
    //   flex-direction: column;
    //   justify-content: space-around;
    //   align-items: center;
    // }
  }

  .footer-wrap {
    width: 100%;
    height: $footerHeight;
    // border: 1px solid;
    display: flex;
    justify-content: space-between;
    align-items: center;

    //上部和底部两边对齐
    padding: 0 15px;

    .footerChart-wrap {
      width: 48vw;
      height: $footerHeight;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
